module.exports = __webpack_public_path__ + "img/6-3.5f3bec59.png";